import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import api from "../../../utils/axios";
import Swal from "sweetalert2";
import QuoteTable from "../../components/Quote/QuoteTableList";
import PendingQuotesModal from "../../components/Modal/Quote/ApprovalQuoteModal";
import { hasOrgPermissionKey } from "../../../utils/orgAccessPermissions";

export default function AdminQuoteListPage() {
  const navigate = useNavigate();

  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openPendingModal, setOpenPendingModal] = useState(false); //  state modal
  const [search, setSearch] = useState("");

  const canQuoteCreate = hasOrgPermissionKey("page.sale_quote.create");
  const canQuoteUpdate = hasOrgPermissionKey("page.sale_quote.update");
  const canQuoteDelete = hasOrgPermissionKey("page.sale_quote.delete");

  //  โหลดข้อมูลใบเสนอราคาทั้งหมด
  const fetchQuotes = async (keyword = "", isInitial = false) => {
    try {
      if (isInitial) setLoading(true);
      const params = keyword ? `?keyword=${encodeURIComponent(keyword)}` : "";
      const res = await api.get(`/get-quotes${params}`);
      setQuotes(res.data?.result || []);
    } catch (error) {
      console.error("โหลดข้อมูลใบเสนอราคาไม่สำเร็จ:", error);
      Swal.fire("ผิดพลาด!", "โหลดข้อมูลไม่สำเร็จ", "error");
    } finally {
      if (isInitial) setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuotes("", true);
  }, []);

  const handleSearchChange = (value) => {
    setSearch(value);
    fetchQuotes(value);
  };

  //  ลบใบเสนอราคา
  const handleDelete = async (quote) => {
    try {
      await api.delete(`/delete-quote/${quote.Doc_Id}`);
      fetchQuotes(search);
    } catch (error) {
      console.error("ลบใบเสนอราคาไม่สำเร็จ:", error);
      Swal.fire("ผิดพลาด!", "เกิดข้อผิดพลาดในการลบข้อมูล", "error");
    }
  };

  //  ไปแก้ไขใบเสนอราคา
  const handleEdit = (quote) => {
    navigate(`/quote/edit/${quote.Doc_Id}?AR_Id=${quote.AR_Id}`);
  };

  //  กรองเฉพาะใบเสนอรออนุมัติ
  const pendingQuotes = quotes.filter((q) => String(q.Doc_Status) === "1");

  //  เปลี่ยนสถานะใบเสนอราคา (1=รออนุมัติ, 2=อนุมัติแล้ว, 3=ยกเลิก)
  const handleStatusChange = async (quote, newStatus) => {
    try {
      const confirm = await Swal.fire({
        title: "ยืนยันการเปลี่ยนสถานะ?",
        text: `ต้องการเปลี่ยนสถานะเป็น "${newStatus === 1 ? "รออนุมัติ" : newStatus === 2 ? "อนุมัติแล้ว" : "ยกเลิก"}" ใช่หรือไม่?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      });

      if (!confirm.isConfirmed) return;

      const payload = { Doc_Status: newStatus };
      const res = await api.put(`/update-quote-status/${quote.Doc_Id}`, payload);

      if (res.data.status === "OK") {
        // Swal.fire({
        //   icon: "success",
        //   title: "สำเร็จ!",
        //   text: "อัปเดตสถานะเรียบร้อย",
        //   timer: 1500,
        //   showConfirmButton: false,
        // });

        fetchQuotes(search); // โหลดข้อมูลใหม่
      } else {
        Swal.fire("ผิดพลาด!", res.data.message || "อัปเดตสถานะไม่สำเร็จ", "error");
      }
    } catch (err) {
      console.error("เปลี่ยนสถานะไม่สำเร็จ:", err);
      Swal.fire("ผิดพลาด!", "เกิดข้อผิดพลาดในการอัปเดต", "error");
    }
  };


  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />
      <main
        className="flex-1 h-screen bg-gray-50 flex flex-col"
        style={{
          height: "100vh",
          overflowX: "hidden",
          overflowY: "hidden",
          marginLeft: "var(--sidebar-width)",
        }}
      >
        <Topbar
          breadcrumbs={[
            { label: "Admin", link: "" },
            { label: "ใบเสนอราคาทั้งหมด" },
          ]}
        />

        <div className="flex-1 min-h-0 overflow-hidden pl-2 pr-8 pb-0 pt-16 flex flex-col">
          <div className="flex justify-between items-center flex-shrink-0 pb-3">

            {/*  ปุ่มเปิด modal */}
            <button
              onClick={() => setOpenPendingModal(true)}
              className="bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-lg shadow"
            >
              รออนุมัติใบเสนอราคา ({pendingQuotes.length})
            </button>
          </div>

          {loading ? (
            <p className="text-gray-500">กำลังโหลดข้อมูล...</p>
          ) : (
            <div className="flex-1 min-h-0 overflow-hidden">
              <QuoteTable
                quotes={quotes}
                onEdit={handleEdit}
                onDelete={handleDelete}
                onStatusChange={handleStatusChange}
                fillAvailable
                showCustomer={true}
                allowCreate={canQuoteCreate}
                allowEdit={canQuoteUpdate}
                allowDelete={canQuoteDelete}
                isAdmin={true}
                search={search}
                onSearchChange={handleSearchChange}
              />
            </div>
          )}
        </div>

        {/*  Modal แสดงใบเสนอรออนุมัติ */}
        <PendingQuotesModal
          isOpen={openPendingModal}
          onClose={() => setOpenPendingModal(false)}
          quotes={pendingQuotes}
        />
      </main>
    </div>
  );
}
